import { ApolloClient, createHttpLink, from, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import type { MutableRefObject } from 'react';

import configuration from '@seller-area/config';

const resolveClientsReportGraphqlUri = () =>
  import.meta.env.VITE_CUSTOMER_API_GRAPHQL || configuration.GATEWAY_API_HOST;

export const createClientsReportApolloClient = (
  tokenRef: MutableRefObject<string | undefined>,
): ApolloClient<unknown> => {
  const httpLink = createHttpLink({
    uri: resolveClientsReportGraphqlUri(),
  });

  const authLink = setContext((_, { headers, ...rest }) => {
    if (!tokenRef.current) return { headers, ...rest };
    return {
      ...rest,
      headers: {
        ...headers,
        Authorization: `Bearer ${tokenRef.current}`,
      },
    };
  });

  return new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
  });
};
